// extracted by mini-css-extract-plugin
export default {"container":"Deactivation_container__ze482","smallContainer":"Deactivation_smallContainer__UQjQj","stepContainer":"Deactivation_stepContainer__ldy2d"};